/* ==========================================================================
   at-home.js  -  Carruseles, marquesina y contadores de la homepage
   --------------------------------------------------------------------------
   Sin dependencias. Los carruseles usan scroll nativo con scroll-snap:
   funcionan con rueda, gesto tactil, teclado y lector de pantalla; las
   flechas solo llaman a scrollBy. Se re-inicializa en los eventos del editor
   de temas para que las secciones se vean bien al editarlas.
   ========================================================================== */
(function () {
  'use strict';

  /* Guarda por si el script llega a incluirse mas de una vez: sin esto cada
     ejecucion vuelve a registrar los listeners globales de shopify:section:*. */
  if (window.__atHomeReady) return;
  window.__atHomeReady = true;

  /* ---------- Medidas en lote ----------
     Leer scrollWidth/clientWidth justo despues de tocar el DOM obliga al
     navegador a recalcular el diseno de la pagina en ese momento. Con ~20
     carruseles eso eran ~20 recalculos seguidos al arrancar (Lighthouse:
     "forced reflow"). Aqui se agrupan: en un solo fotograma se hacen primero
     todas las lecturas y despues todas las escrituras. Cada tarea es una
     funcion que lee y devuelve otra funcion (opcional) que escribe. */
  var measureQueue = [];
  function measure(job) {
    if (!measureQueue.length) {
      /* requestAnimationFrame no salta en pestanas ocultas; el setTimeout es la
         red de seguridad. Lo que llegue primero vacia la cola; el otro no hace nada. */
      var flush = function () {
        var jobs = measureQueue; measureQueue = [];
        var writes = jobs.map(function (j) { return j(); });
        writes.forEach(function (w) { if (typeof w === 'function') w(); });
      };
      requestAnimationFrame(flush);
      setTimeout(flush, 200);
    }
    measureQueue.push(job);
  }

  /* ---------- Carruseles ---------- */
  function initRail(rail) {
    if (!rail || rail.dataset.atRailReady === '1') return;
    rail.dataset.atRailReady = '1';

    var id = rail.id;
    var prev = id ? document.querySelector('[data-at-nav="prev"][data-at-target="' + id + '"]') : null;
    var next = id ? document.querySelector('[data-at-nav="next"][data-at-target="' + id + '"]') : null;

    function step() {
      return Math.max(240, rail.clientWidth * 0.85);
    }
    function read() {
      var max = rail.scrollWidth - rail.clientWidth - 2, left = rail.scrollLeft;
      return function () {
        if (prev) prev.disabled = left <= 2;
        if (next) next.disabled = left >= max;
      };
    }
    function sync() { read()(); }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    measure(read);

    rail._atSync = sync;

    /* ---------- Movimiento automatico ----------
       Se activa con data-at-autoplay="segundos" (lo pone cada seccion desde su
       ajuste). Avanza una "pagina" cada N segundos y, al llegar al final, vuelve
       al principio. Se detiene:
       - mientras el raton esta encima o hay algo con el foco dentro (teclado);
       - mientras la persona toca el carrusel;
       - si el carrusel no esta a la vista o la pestana esta oculta;
       - para siempre en cuanto la persona usa las flechas, la rueda o el teclado,
         porque ya ha decidido que quiere moverlo ella (WCAG 2.2.2);
       - siempre, si el sistema pide menos movimiento. */
    var secs = parseFloat(rail.dataset.atAutoplay);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (secs > 0 && !reduce) {
      var hold = false, seen = false, stopped = false, timer = null, touchTimer = null;

      function tick() {
        if (stopped || hold || !seen || document.hidden) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (max <= 0) return;
        if (rail.scrollLeft >= max) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: step(), behavior: 'smooth' });
      }
      function give_up() { stopped = true; clearInterval(timer); }

      rail.addEventListener('mouseenter', function () { hold = true; });
      rail.addEventListener('mouseleave', function () { hold = false; });
      rail.addEventListener('focusin', function () { hold = true; });
      rail.addEventListener('focusout', function () { hold = false; });
      rail.addEventListener('touchstart', function () { hold = true; clearTimeout(touchTimer); }, { passive: true });
      rail.addEventListener('touchend', function () { clearTimeout(touchTimer); touchTimer = setTimeout(function () { hold = false; }, 6000); }, { passive: true });
      rail.addEventListener('wheel', give_up, { passive: true });
      rail.addEventListener('keydown', give_up);
      [prev, next].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', give_up);
        b.addEventListener('mouseenter', function () { hold = true; });
        b.addEventListener('mouseleave', function () { hold = false; });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; }); }, { threshold: 0.35 }).observe(rail);
      } else { seen = true; }
      timer = setInterval(tick, secs * 1000);
    }
  }

  /* ---------- Bordes con degradado y flecha ----------
     Cuando en un carrusel queda un producto cortado a la izquierda o a la derecha,
     ese lado se desvanece con un degradado y aparece una flecha para moverlo.
     Cada lado solo se ve si hay mas contenido por ese lado. Se salta el carrusel de
     categorias y las tarjetas de ofertas, que ya traen sus propias flechas. */
  function pageBg(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var c = getComputedStyle(n).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(c)) return c;
    }
    return '#fff';
  }
  function initEdges(rail) {
    if (!rail || rail.dataset.atEdgesReady === '1') return;
    if (rail.classList.contains('at-v2-icons__rail') || rail.classList.contains('at-v2-offers')) return;
    rail.dataset.atEdgesReady = '1';

    var wrap = document.createElement('div');
    wrap.className = 'at-v2-edges';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    function make(side) {
      var shade = document.createElement('span');
      shade.className = 'at-v2-edge at-v2-edge--' + side;
      shade.setAttribute('aria-hidden', 'true');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'at-v2-edge__btn';
      b.setAttribute('aria-label', side === 'prev' ? 'Scroll left' : 'Scroll right');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="' + (side === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      shade.appendChild(b);
      wrap.appendChild(shade);
      b.addEventListener('click', function () {
        var id = rail.id;
        var nav = id ? document.querySelector('[data-at-nav="' + side + '"][data-at-target="' + id + '"]') : null;
        if (nav && !nav.disabled) { nav.click(); return; }
        var step = Math.max(240, rail.clientWidth * 0.85);
        rail.scrollBy({ left: side === 'prev' ? -step : step, behavior: 'smooth' });
      });
      return shade;
    }
    var left = make('prev'), right = make('next');

    function read() {
      var max = rail.scrollWidth - rail.clientWidth, pos = rail.scrollLeft;
      return function () {
        left.classList.toggle('is-on', pos > 4);
        right.classList.toggle('is-on', max > 4 && pos < max - 4);
      };
    }
    function sync() { read()(); }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    var prevSync = rail._atSync;
    rail._atSync = function () { if (prevSync) prevSync(); sync(); };
    /* Primera medida en lote; el ResizeObserver se engancha despues para que
       su aviso inicial no repita la medida durante el arranque. */
    measure(function () {
      var bg = pageBg(wrap), w = read();
      return function () {
        wrap.style.setProperty('--at-edge-bg', bg);
        w();
        if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
      };
    });
    setTimeout(sync, 400);
    window.addEventListener('load', sync);
  }

  /* ---------- Segunda foto en tarjetas (movil / tactil) ----------
     En escritorio con raton la segunda foto sale con :hover (solo CSS). En pantallas
     tactiles no hay hover, asi que mientras una tarjeta esta a la vista se alterna
     sola entre la primera y la segunda foto cada pocos segundos. Se detiene al
     salir de pantalla, con la pestana oculta o si el sistema pide menos movimiento. */
  function initAltImages(scope) {
    var touch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* La segunda foto solo se usa cuando existe y ya esta descargada (.has-alt);
       si no, la primera se queda y nunca aparece un hueco en blanco. Se pide en
       cuanto el raton entra o la tarjeta se toca, aunque la carga diferida no
       la hubiera traido todavia. */
    (scope || document).querySelectorAll('.at-v2-card').forEach(function (card) {
      var img2 = card.querySelector('.at-v2-card__img2');
      if (!img2 || card.dataset.atAltInit === '1') return;
      card.dataset.atAltInit = '1';
      function ready() {
        if (img2.complete && img2.naturalWidth > 0) card.classList.add('has-alt');
        else card.classList.remove('has-alt');
      }
      img2.addEventListener('load', ready);
      img2.addEventListener('error', function () { card.classList.remove('has-alt'); });
      function fetchNow() { if (img2.loading === 'lazy') img2.loading = 'eager'; ready(); }
      card.addEventListener('mouseenter', fetchNow);
      card.addEventListener('touchstart', fetchNow, { passive: true });
      ready();
    });

    if (!touch || reduce || !('IntersectionObserver' in window)) return;
    var timers = new WeakMap();
    function stop(card) {
      var t = timers.get(card);
      if (t) { clearInterval(t.i); clearTimeout(t.s); timers.delete(card); }
      card.classList.remove('is-alt');
    }
    function start(card) {
      if (timers.has(card)) return;
      var t = {};
      /* arranque escalonado para que no cambien todas a la vez */
      t.s = setTimeout(function () {
        var img2 = card.querySelector('.at-v2-card__img2');
        if (img2 && img2.loading === 'lazy') img2.loading = 'eager';
        t.i = setInterval(function () {
          if (document.hidden || !card.classList.contains('has-alt')) return;
          card.classList.toggle('is-alt');
        }, 2600);
      }, 900 + Math.random() * 1400);
      timers.set(card, t);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) start(e.target); else stop(e.target); });
    }, { threshold: 0.6 });
    (scope || document).querySelectorAll('.at-v2-card').forEach(function (card) {
      if (card.dataset.atAltReady === '1' || !card.querySelector('.at-v2-card__img2')) return;
      card.dataset.atAltReady = '1';
      io.observe(card);
    });
  }

  /* ---------- Filtros de ofertas ---------- */
  function initFilters(group) {
    if (!group || group.dataset.atFiltersReady === '1') return;
    group.dataset.atFiltersReady = '1';

    var rail = document.getElementById(group.dataset.atTarget);
    if (!rail) return;
    var btns = group.querySelectorAll('[data-at-filter]');
    /* Pestanas de subcategoria del Product rail: cada boton puede llevar su
       propio enlace "View all" (data-at-url). */
    var scope = group.closest('.at-v2-wrap');
    var more = scope ? scope.querySelector('[data-at-more]') : null;

    btns.forEach(function (b) {
      if (b.tagName === 'A') {
        b.addEventListener('keydown', function (e) {
          if (e.key === ' ') { e.preventDefault(); b.click(); }
        });
      }
      b.addEventListener('click', function (e) {
        /* Las pestanas son enlaces: Ctrl/Cmd/Shift/clic central siguen abriendo
           la coleccion; un clic normal solo filtra. */
        if (b.tagName === 'A') {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
          e.preventDefault();
        }
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        rail.classList.remove('at-v2-rail--tabs-init');
        if (more && b.dataset.atUrl) more.setAttribute('href', b.dataset.atUrl);

        var f = b.dataset.atFilter;
        function show() {
          rail.querySelectorAll('[data-at-cat]').forEach(function (card) {
            var cats = (card.dataset.atCat || '').split(' ');
            card.hidden = !(f === 'all' || cats.indexOf(f) !== -1);
          });
          rail.scrollTo({ left: 0, behavior: 'smooth' });
          if (rail._atSync) rail._atSync();
        }

        /* Pestana con data-at-src: sus tarjetas se piden la primera vez que se
           pulsa (collection.at-rail) y se quedan en el carrusel. Mientras llegan,
           el carrusel sigue mostrando lo anterior. Si no hay productos, la
           pestana se oculta y se vuelve a "All". */
        var src = b.dataset.atSrc;
        if (!src || b.dataset.atLoaded === '1') { show(); return; }
        if (b.dataset.atLoading === '1') return;
        b.dataset.atLoading = '1';
        rail.setAttribute('aria-busy', 'true');
        fetch(src + (src.indexOf('?') === -1 ? '?' : '&') + 'view=at-rail', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .catch(function () { return null; })
          .then(function (html) {
            b.dataset.atLoading = '';
            rail.removeAttribute('aria-busy');
            /* Error de red o del servidor: no se oculta nada; el siguiente clic lo
               vuelve a intentar y el enlace sigue llevando a la coleccion. */
            if (html === null) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('.at-v2-card');
            if (!cards.length) {
              b.hidden = true;
              var first = group.querySelector('[data-at-filter="main"]');
              if (first && b.getAttribute('aria-pressed') === 'true') first.click();
              return;
            }
            cards.forEach(function (card) {
              card.setAttribute('data-at-cat', f);
              rail.appendChild(document.importNode(card, true));
            });
            b.dataset.atLoaded = '1';
            initAltImages(rail);
            /* Solo cambia la vista si la persona sigue en esta pestana. */
            if (b.getAttribute('aria-pressed') === 'true') show();
          });
      });
    });
  }

  /* ---------- Marquesina de marcas ----------
     El track se duplica para que el bucle a -50% sea continuo. La copia se
     marca aria-hidden para que el lector de pantalla no lea las marcas dos
     veces. Si el usuario pide menos movimiento, no se duplica: la CSS deja
     la fila con scroll manual. */
  function initMarquee(marq) {
    if (!marq || marq.dataset.atMarqReady === '1') return;
    marq.dataset.atMarqReady = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var track = marq.querySelector('[data-at-marq-track]');
    if (!track || track.children.length === 0) return;

    var copy = track.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    while (copy.firstChild) track.appendChild(copy.firstChild);
  }

  /* ---------- Contadores ----------
     data-at-countdown lleva la fecha fin en ISO. Dentro, los elementos
     [data-at-cd="d|h|m|s"] reciben el valor, y [data-at-cd="full"] la
     cadena completa. Al llegar a cero se oculta el contenedor. */
  var timers = [];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(el) {
    if (!el || el.dataset.atCdReady === '1') return;
    el.dataset.atCdReady = '1';

    var end = new Date(el.dataset.atCountdown);
    if (isNaN(end.getTime())) { el.hidden = true; return; }

    function tick() {
      var s = Math.floor((end - new Date()) / 1000);
      if (s <= 0) { el.hidden = true; return false; }

      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;

      var set = function (k, v) {
        var n = el.querySelector('[data-at-cd="' + k + '"]');
        if (n) n.textContent = v;
      };
      set('d', pad(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(sec));
      set('full', pad(d) + 'd ' + pad(h) + 'h ' + pad(m) + 'm');
      return true;
    }

    if (tick()) timers.push(setInterval(tick, 1000));
  }

  /* ---------- Anadir al carrito sin recargar ---------- */
  function initAdd(form) {
    if (!form || form.dataset.atAddReady === '1') return;
    form.dataset.atAddReady = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.atAdding || 'Adding...'; }

      /* El carrito lateral del tema (<cart-drawer>) no escucha ningun evento:
         hay que pedirle a /cart/add.js sus secciones ya pintadas y pasarselas a
         renderContents(), que las coloca y abre el cajon. Igual que hace el
         boton principal de la ficha (product-form.js). */
      var cart = document.querySelector('cart-drawer');
      var useDrawer = !!(cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function');
      var body = new FormData(form);
      if (useDrawer) {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn || document.activeElement);
      }

      fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
          if (btn) btn.textContent = btn.dataset.atAdded || 'Added';
          document.dispatchEvent(new CustomEvent('at:cart:added', { detail: res.data }));
          if (useDrawer && res.data.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(res.data);
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        })
        .catch(function (err) {
          if (btn) btn.textContent = err.message;
        })
        .finally(function () {
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          }, 2000);
        });
    });
  }

  /* ---------- Carrusel del hero ----------
     Avanza empujando el scroll del track, que lleva scroll-snap. No hay
     animacion propia en paralelo, asi que la posicion visible y la que cree el
     script no pueden desincronizarse: el indice siempre se lee del scroll real.

     Se detiene solo en cuatro situaciones, y las cuatro importan:
       - Al pasar el raton o enfocar con el teclado, para no arrancarle la
         diapositiva a quien la esta leyendo.
       - Al pulsar el boton de pausa. La WCAG 2.2.2 lo exige para cualquier
         contenido en movimiento que dure mas de cinco segundos.
       - Con la pestana en segundo plano, que ademas ahorra bateria.
       - Con prefers-reduced-motion no arranca siquiera. */
  function initSlider(root) {
    if (!root || root.dataset.atSliderReady === '1') return;
    root.dataset.atSliderReady = '1';

    var track = root.querySelector('[data-at-slider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-at-slider-dot]'));
    var prev = root.querySelector('[data-at-slider-prev]');
    var next = root.querySelector('[data-at-slider-next]');
    var pauseBtn = root.querySelector('[data-at-slider-pause]');

    var delay = parseInt(root.dataset.atAutoplay, 10) || 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var pausadoPorUsuario = false;

    function indice() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function ir(i) {
      var n = slides.length;
      var destino = ((i % n) + n) % n;          // envuelve en los dos sentidos
      track.scrollTo({ left: destino * track.clientWidth, behavior: 'smooth' });
    }
    function pintar() {
      var i = indice();
      dots.forEach(function (d, k) {
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      slides.forEach(function (s, k) {
        // las diapositivas fuera de vista no deben ser alcanzables con el tabulador
        var fuera = k !== i;
        s.querySelectorAll('a, button').forEach(function (el) {
          if (fuera) { el.setAttribute('tabindex', '-1'); }
          else { el.removeAttribute('tabindex'); }
        });
      });
    }

    function arrancar() {
      if (!delay || reduced || pausadoPorUsuario || timer) return;
      timer = setInterval(function () { ir(indice() + 1); }, delay);
      if (pauseBtn) pauseBtn.setAttribute('aria-pressed', 'false');
    }
    function parar(porUsuario) {
      if (timer) { clearInterval(timer); timer = null; }
      if (porUsuario && pauseBtn) pauseBtn.setAttribute('aria-pressed', 'true');
    }

    if (prev) prev.addEventListener('click', function () { ir(indice() - 1); });
    if (next) next.addEventListener('click', function () { ir(indice() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { ir(parseInt(d.dataset.atSliderDot, 10)); });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        pausadoPorUsuario = !pausadoPorUsuario;
        if (pausadoPorUsuario) {
          parar(true);
          pauseBtn.setAttribute('aria-label', pauseBtn.dataset.atPlayLabel || 'Play promotions');
        } else {
          pauseBtn.setAttribute('aria-label', pauseBtn.dataset.atPauseLabel || 'Pause promotions');
          arrancar();
        }
      });
    }

    root.addEventListener('mouseenter', function () { parar(false); });
    root.addEventListener('mouseleave', arrancar);
    root.addEventListener('focusin', function () { parar(false); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) arrancar();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { parar(false); } else { arrancar(); }
    });

    var reloj = null;
    track.addEventListener('scroll', function () {
      clearTimeout(reloj);
      reloj = setTimeout(pintar, 90);
    }, { passive: true });

    window.addEventListener('resize', function () {
      // tras cambiar de tamano el scroll queda entre dos diapositivas
      ir(indice());
    });

    /* Editor de temas. Al seleccionar una diapositiva en el panel lateral, el
       editor emite shopify:block:select sobre el elemento del bloque. Sin esto
       habria que esperar a que el carrusel pasase solo por ella para verla, que
       es justo lo que vuelve incomodo montar un slider.
       Mientras hay una seleccionada el avance automatico se detiene, para no
       arrastrar la diapositiva que se esta editando. Al deseleccionar, sigue.
       Solo se engancha en designMode: en la tienda publicada estos eventos no
       existen y no tiene sentido cargar los listeners. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i === -1) return;                  // era un tile, no una diapositiva
        parar(false);
        // en cuanto el editor termina de insertar el bloque ya hay medidas
        requestAnimationFrame(function () { ir(i); });
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        if (slides.indexOf(e.target) === -1) return;
        arrancar();
      });
    }

    pintar();
    arrancar();
  }

  /* ---------- Arranque ---------- */
  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-at-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-at-rail]').forEach(initRail);
    scope.querySelectorAll('[data-at-rail]').forEach(initEdges);
    initAltImages(scope);
    scope.querySelectorAll('[data-at-filters]').forEach(initFilters);
    scope.querySelectorAll('[data-at-marq]').forEach(initMarquee);
    scope.querySelectorAll('[data-at-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-at-add]').forEach(initAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Cualquier elemento con data-klaviyo-form abre ese formulario de Klaviyo (el popup de registro).
     Si Klaviyo aun no ha cargado, la orden queda en cola y se abre al cargar. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-klaviyo-form]');
    if (!t) return;
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', t.getAttribute('data-klaviyo-form')]);
  });

  /* Editor de temas: al cargar o recargar una seccion, re-inicializar solo esa. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    timers.forEach(clearInterval);
    timers = [];
  });
})();
